import React, { Suspense, lazy } from "react";
import { CelligenceFooter } from "footer-component";
import Container from "react-bootstrap/Container";
import "./index.css";

const CustomFooter = () => {
  return (
    <div className="angl-footer">
      {/* <Container >
        <p className="footer-disclaimers">
          Visit <a href="https://www.angeltwin.com/terms" target="_blank" rel="noreferrer noopener">angeltwin.com/terms</a> for Angel Twin terms of service.
        </p>
        <p className="footer-disclaimers">
          For licensing information, go to: <a href="https://www.nmlsconsumeraccess.org/" target="_blank" rel="noreferrer noopener">www.nmlsconsumeraccess.org</a>.
        </p>
        <p className="footer-disclaimers">
          Visit <a href="https://www.swmc.com/disclaimer" target="_blank" rel="noreferrer noopener">https://www.swmc.com/disclaimer</a> for the full list of license information.
        </p>
        <p className="footer-disclaimers">
          Please <a href="https://www.swmc.com/txdis" target="_blank" rel="noreferrer noopener">Click Here</a> to view Texas Complaint Notice and Servicing Disclosure.
        </p>
        <p className="footer-disclaimers-last">
          Bruce Buffer is a paid spokesperson for <a href="https://www.celligence.com/" target="_blank" rel="noreferrer noopener">Celligence International, LLC</a>, the creators of AngelAi.
        </p>
      </Container> */}
      <CelligenceFooter type="celligence" />
    </div>
  );
};

export default CustomFooter;
